import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

class SexSelector extends React.Component {

  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    return {
      selected: props.selectedChoice,
      choices: props.choices,
    };
  }

  componentDidMount() {
    if (this.state.selected) { this.props.onSelection(this.state.selected); }
  }

  render () {
    const odd = this.state.choices.length % 2 == 1;
    const buttonClass = (odd) ? 'three-column' : '';

    return (
      <div className={`sex-selector button-select ${this.props.className}`}>
        { this.state.choices.map((choice) =>
          <Button
            className={`sex-selector__button sex-selector__button--${choice.id} ${buttonClass}`}
            label={choice.label}
            key={choice.id}
            selected={(this.state.selected == choice.id)}
            onClick={this.onAnswer.bind(this, choice.id)}
          />
        )}
      </div>
    );
  }

  onAnswer(choice) {
    this.setState({ selected: choice }, () => {
      this.props.onSelection(choice);
    });
  }

}

SexSelector.defaultProps = {
  className: ''
};

SexSelector.propTypes = {
  className: PropTypes.string,
  choices: PropTypes.array.isRequired,
  selectedChoice: PropTypes.string,
  onSelection: PropTypes.func.isRequired
};

export default SexSelector;
